import type { ReactNode } from 'react';

import { cx } from '@/utils/cx';

interface OverviewGroupLabelProps {
  children: ReactNode;
  className?: string;
}

/**
 * Micro label that names a group of rows inside the record overview / details
 * rail — "AI summary" above the summary prose, "Booking questions" above the
 * decomposed answer rows. Rendered in natural case and uppercased by CSS so
 * search, translation, and screen readers see the real words.
 *
 * Deliberately the lightest possible chrome: a label, no border, no box. It
 * gives a run of otherwise-native rows a provenance without pulling them out
 * of the rail's `icon → label → value` rhythm.
 */
export function OverviewGroupLabel({
  children,
  className,
}: OverviewGroupLabelProps) {
  return (
    <p
      className={cx(
        'text-[11px] font-medium uppercase tracking-wide text-[var(--color-text-tertiary)]',
        className
      )}
    >
      {children}
    </p>
  );
}
